import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface CountdownProps {
  targetDate?: string;
}

export function Countdown(props: CountdownProps) {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState<number>(0);

  const updateTimeLeft = () => {
    const now = dayjs();
    const target = dayjs(props.targetDate);

    if (target.isAfter(now)) {
      setTimeLeft(target.diff(now, 'second'));
    } else {
      setTimeLeft(0);
    }
  };

  useEffect(() => {
    updateTimeLeft();
    const interval = setInterval(updateTimeLeft, 1000);
    return () => clearInterval(interval);
  }, [props.targetDate]);

  const days = Math.floor(timeLeft / (3600 * 24));
  const hms = dayjs.unix(timeLeft).format('LTS');

  return <>{timeLeft > 0 && `${days}d ${hms}`}</>;
}
